<template>
  <RadioGroup v-model="selectedValue" @change="updateListingType" class="inline-flex justify-center m-auto duration-300 ease-in-out items-center p-1 bg-surface-color-100 rounded-full default-shadow group-checked:ring-border-color-200 min-w-[213px]" as="div">
    <!-- Option for Sale -->
    <RadioGroupOption value="sale" as="template" v-slot="option" @click="updateListingType('sale')">
      <button type="button"
              :class="[
                'px-4 py-2 rounded-full hover:text-text-color-200 cursor-pointer font-medium leading-6 w-[96px] justify-center',
                option && option.checked ? 'text-text-color-200 cursor-default ring-1 ring-border-color-200 bg-surface-color-500' : 'text-text-color-light-100'
              ]">
        {{ saleLabel }}
      </button>
    </RadioGroupOption>
    <!-- Option for Rent -->
    <RadioGroupOption value="rent" as="template" v-slot="option" @click="updateListingType('rent')">
      <button type="button"
              :class="[
                'px-4 py-2 rounded-full hover:text-text-color-200 cursor-pointer font-medium leading-6 w-[109px] justify-center',
                option && option.checked ? 'text-text-color-200 cursor-default ring-1 ring-border-color-200 bg-surface-color-500' : 'text-text-color-light-100'
              ]">
        {{ rentLabel }}
      </button>
    </RadioGroupOption>
  </RadioGroup>
</template>

<script setup>
import { ref, watch } from 'vue';
import { RadioGroup, RadioGroupOption } from '@headlessui/vue';

const props = defineProps({
  saleLabel: String,
  rentLabel: String,
  modelValue: String,
});

const emit = defineEmits(['update:modelValue']);
const selectedValue = ref(props.modelValue);

watch(selectedValue, (newValue) => {
  emit('update:modelValue', newValue);
});
function updateListingType(value) {
  selectedValue.value = value;
}
</script>
